import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const Wave = (props: TSvgAssetProps) => (
  <SvgAsset width="18" height="5" viewBox="0 0 18 5" fill="none" {...props}>
    <path d="M17 2.5C14.3333 4.5 11.6667 4.5 9 2.5C6.33333 0.5 3.66667 0.5 1 2.5" stroke="#002373" strokeWidth="1.2" />
  </SvgAsset>
);

export default Wave;
